<template>
    <div>
    <div v-if="!number">
         <login />
    </div>
    <div v-if="number">
    <CContainer fluid class="contain">     
   <CContainer fluid>     
            <h1>{{this.esporteelazer.titulo}}</h1>
             <h2 class="pt-1"><span>Agradecemos a você por ter chegado até aqui! <br><br>
            Então, queremos saber o que precisa ser melhorado em Timóteo? <br><br>
            Você tem a opção de escolher a prioridade dentre as opções descritas abaixo. <br><br>
            Caso a prioridade que você queira indicar não tenha sido contemplada, você pode sugeri-la digitando no espaço reservado ao final do formulário. <br><br> 
            Confirme a sua resposta e participe nos demais temas propostos. <br><br>
             A sua participação é muito importante para Timóteo continuar avançando. Vamos desenvolver a cidade juntos!
            </span></h2>
         <CContainer class="mt-4" fluid>   
            <section>           
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_29" name="select" value="Ampliar o acesso da população ao esporte e ao lazer nas sete regionais do Município.">
            <label for="control_29">               
               <p class="pt-4">Ampliar o acesso da população ao esporte e ao lazer nas sete regionais do Município.</p>
            </label>
            </div>
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_30" name="select" value="Estruturar ações de fomento e incentivo ao esporte e ao lazer.">
            <label for="control_30">               
               <p class="pt-4">Estruturar ações de fomento e incentivo ao esporte e ao lazer.</p>
            </label>
            </div>
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_31" name="select" value="Buscar parcerias junto ao setor privado para a manutenção das Olimpíadas Escolares.">
            <label for="control_31">               
               <p class="pt-4">Buscar parcerias junto ao setor privado para a manutenção das Olimpíadas Escolares.</p>
            </label>
            </div>
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_32" name="select" value="Assegurar a participação de alunos e atletas nos Jogos Escolares de Minas Gerais e Jogos do Interior de Minas (JIMI).">
            <label for="control_32">               
               <p class="pt-4">Assegurar a participação de alunos e atletas nos Jogos Escolares de Minas Gerais e Jogos do Interior de Minas (JIMI).</p>
            </label>
            </div>
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_33" name="select" value="Oportunizar o acesso intergeracional ao Ginásio Poliesportivo Iorque José Martins.">
            <label for="control_33">               
               <p class="pt-4">Oportunizar o acesso intergeracional ao Ginásio Poliesportivo Iorque José Martins.</p>
            </label>
            </div>
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_34" name="select" value="Garantir o funcionamento dos núcleos do Programa Humanizar.">
            <label for="control_34">               
               <p class="pt-4">Garantir o funcionamento dos núcleos do Programa Humanizar.</p>
            </label>
            </div>
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_35" name="select" value="Buscar junto às instâncias estadual e federal a construção, ampliação e reforma de equipamentos públicos esportivos e de lazer.">
            <label for="control_35">               
               <p class="pt-4">Buscar junto às instâncias estadual e federal a construção, ampliação e reforma de equipamentos públicos esportivos e de lazer.</p>
            </label>
            </div>
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_36" name="select" value="Manter o funcionamento efetivo do Conselho Municipal de Esporte e Lazer.">
            <label for="control_36">               
               <p class="pt-4">Manter o funcionamento efetivo do Conselho Municipal de Esporte e Lazer.</p>
            </label>
            </div>
            <div>
            <input v-model="esporteelazer.resposta" :disabled="abrirsugestao || esporteelazer.desabilita" type="radio" id="control_37" name="select" value="Manter o município habilitado junto ao Programa ICMS Esportivo do Governo de Minas Gerais.">
            <label for="control_37">               
               <p class="pt-4">Manter o município habilitado junto ao Programa ICMS Esportivo do Governo de Minas Gerais.</p>
            </label>
            </div>
            
            </section>
            </CContainer>
          </CContainer>
            <div class="form-group">

                            <div class="form-check form-check-inline ml-5 mt-3">
                              <input 
                                :disabled="esporteelazer.desabilita"
                                type="checkbox" 
                                class="form-check-input"
                                v-model="abrirsugestao"                                >
                              <p class="form-check-label"><i class="far fa-hand-point-left mr-1"></i>Marque aqui se quiser sugerir um tema diferente das opções acima?</p>
                            </div>

                          </div>

               <div>
               <div class="form-group">                            
                            <textarea 
                              :disabled="!abrirsugestao || esporteelazer.desabilita"
                              class="form-control" 
                              placeholder="Conte-nos a sua sugestão..."
                              v-model="esporteelazer.resposta">
                            </textarea>
                          </div>                         
               </div>
            
                 <CButton color="success" @click="myModal = true"  :disabled="esporteelazer.desabilita || camposnull" class="mr-3 float-right mb-4" style="width: 9rem;">
                Confirmar
              </CButton>  
              <CButton color="danger" to="/perguntas" class="mr-3 float-right mb-4" style="width: 9rem;">
                Voltar
              </CButton> 
                         

     <CModal
      :show.sync="myModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"      
      color="dark"
    >
      Sua resposta foi encaminhada com sucesso. Aproveite para responder outras perguntas também! 
      <template #header>
        <h6 class="modal-title">Obrigado por participar! </h6>
        <CButtonClose @click="myModal = false" class="text-white"/>
      </template>
      <template #footer>        
        <CButton @click="myModal = false, limpasugestao(), confirma(), salvar(), numero(), redirect()" color="success">Confirmar</CButton>
      </template>
    </CModal>
   </CContainer>
<!-- FIM PERGUNTA 2 -->
    </div>
    </div>
</template>

<script>
import firebase from 'firebase'
import login from '@/components/Verificacao.vue'

export default {
    name: 'Pergunta4esport', 
    components: {
    login,   
    },
    data () {
    return {
         myModal: false, 
         phoneNumber:null,
         number: null,
         administra: {},         
         esporteelazer: {
                resposta: null, 
                desabilita: true,
                titulo: "Esporte e Lazer",
                createdOn: new Date()
              },          
          abrirsugestao: false,
          telefone: []                                              
         }          
      },   
   created()    {
        this.campos = localStorage.getItem('dadosApp')
        // console.log(this.campos)

         let tel = JSON.parse(this.campos)
         let a =  tel
        // console.log(a)
         this.telefone1 = a

        // console.log(this.telefone1)

         this.number = this.telefone1

        // console.log(this.number)
        

        this.$http.get(`${this.number}/resposta/esporteelazer.json`)
            .then(resposta =>{                                         
                if (!resposta.data) {                   
                  this.esporteelazer.desabilita = false 
                //  console.log(resposta.data)
                  this.administra = resposta.data                    
                //  console.log(this.administra)
                } else {
                  const array = []
                for(let chave in resposta.data) {
                array.push({ id: chave, ...resposta.data[chave] })                
                }       
                let a = []
                a = array[0]
                this.esporteelazer = a.esporteelazer
                //console.log(this.administracaoegestao)
              }
            })

        this.$http.get(`${this.number}/usuario.json`)
            .then(resposta =>{                                         
                if (!resposta.data)                    
                  this.esporteelazer.desabilita = true 
                 // console.log(resposta.data)                  
            })

    },  
   computed: {
     camposnull() {
       if(!this.esporteelazer.resposta)
       return true
     }
          
   },
   methods: {    
      redirect() {
        setTimeout(function () {
          window.location.replace('/perguntas')
        }, 500);
      }, 
      confirma() {        
        this.esporteelazer.desabilita = true
        //console.log(this.esporteelazer.resposta)        
      },
        limpasugestao() {
          if (!this.abrirsugestao) {
            this.esporteelazer.sugestao = null
          }  if (this.abrirsugestao) {
            this.esporteelazer.resposta = null
          } 
      },
      salvar() {             
              this.$http.post(`${this.number}/resposta/esporteelazer.json`, {
               esporteelazer: this.esporteelazer                  
              })     
              
          },   
      numero() {
        //console.log(this.number)
      },       
       /* 
      salvar() {
              this.$http.post(`${this.telefone1}.json`, {
                  telefone: this.telefone1,
                  nome: this.name,
                  email: this.email,    
                  bairro: this.bairro,    
                  acceptTerms: this.acceptTerms,
                  respostas: this.respostas               
              })    
          },
       */
   },
   mounted() {
        /* this.$http.get(`${this.telefone1}/${this.slug}.json`)
            .then(resposta=>{                                         
                if (!resposta.data)                    
                  this.telefone = true
                  this.telefoneCA = true
                                
                
                  console.log(resposta)
                  console.log(this.telefoneCAd)
                  console.log(this.telefone)
                  console.log(this.telefone1)
            }
        })            */ 
    }  
  
}
</script>

<style scoped lang="scss">


@import url('https://fonts.googleapis.com/css?family=Raleway:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i');

/**-- font-family: 'Raleway', sans-serif; --**/


/*------------------------------------------------------------- 
	2. BASE CSS 
-------------------------------------------------------------*/

.contain{
  padding-top: 1.8rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

h2, .h2 {
    font-size: 1rem;    
    text-align: justify; 
    font-weight: 500;   
}

body {
  padding: 1rem;  
  	background-color: #07203e import;
   
}
h1 {
  color: hsla(215, 5%, 10%, 1);
  margin-bottom: 1rem;
}
section {
  display: flex;
  flex-flow: row wrap;
}
section > div {
  flex: 1;
  padding: 0.5rem;
}
input[type="radio"] {
  display: none;
  &:not(:disabled) ~ label {
    cursor: pointer;
  }
  &:disabled ~ label {
    color: hsla(150, 5%, 75%, 1);
    border-color: hsla(150, 5%, 75%, 1);
    box-shadow: none;
    cursor: not-allowed;
  }
}
label {
  height: 100%;
  display: block;
  background: white;
  border: 2px solid hsla(150, 75%, 50%, 1);
  border-radius: 20px;
  padding: 1rem;
  margin-bottom: 1rem;
  //margin: 1rem;
  text-align: center;
  box-shadow: 0px 3px 10px -2px hsla(150, 5%, 65%, 0.5);
  position: relative;
}
input[type="radio"]:checked + label {
  background: hsla(150, 75%, 50%, 1);
  color: hsla(215, 0%, 100%, 1);
  box-shadow: 0px 0px 20px hsla(150, 100%, 50%, 0.75);
  &::after {
    color: hsla(215, 5%, 25%, 1);
    font-family: FontAwesome;
    border: 2px solid hsla(150, 75%, 45%, 1);
    content: "\f00c";
    font-size: 24px;
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    height: 50px;
    width: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 50%;
    background: white;
    box-shadow: 0px 2px 5px -2px hsla(0, 0%, 0%, 0.25);
  }
}
/* input[type="radio"]#control_05:checked + label {
  background: red;
  border-color: red;
}

*/
p {
  font-weight: 900;
}


@media only screen and (max-width: 700px) {
  section {
    flex-direction: column;
  }
}

</style>